/*
 * Copyright (c) 2018. CPP, Inc. All rights reserved.
 * Also protected by Patent Pending: 15/916,593
 */

import { compose, setDisplayName, setPropTypes } from 'recompose'
import { graphql } from 'gatsby'
import PropTypes from 'prop-types'

import PhotoDisplay from 'compositions/Photo'
import photoNavigationShape from 'shapes/PhotoNavigation'
import photoShape from 'shapes/Photo'

const PhotosTemplate = compose(
  setDisplayName('PhotosTemplate'),
  setPropTypes({
    data: PropTypes.shape({
      photo: photoShape.raw,
      photos: photoNavigationShape.raw,
    }),
  })
)(PhotoDisplay)

export default PhotosTemplate

export const query = graphql`
  query($slug: String!) {
    photos: allImageSharp(
      filter: { fields: { plotType: { eq: "Photo" } } }
      sort: { fields: [fields___title] }
    ) {
      ...PhotoNav
    }

    photo: imageSharp(fields: { slug: { eq: $slug } }) {
      ...Photo
    }
  }
`
